import { render, staticRenderFns } from "./SlugContentComponent.vue?vue&type=template&id=9c3a0690&scoped=true&"
import script from "./SlugContentComponent.vue?vue&type=script&lang=js&"
export * from "./SlugContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./SlugContentComponent.vue?vue&type=style&index=0&id=9c3a0690&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3a0690",
  null
  
)

export default component.exports